module.exports = __webpack_public_path__ + "img/guest.5405d77c.png";